import INDUSTRIES from "./industries";

export default value => {
    const data = INDUSTRIES.find((i) => i.value === value);

    return data ? data.text : "N/A";
}
